// Don't include a backslash at the end of an URL
var deltaPOS_conf = {
  title: '',
  itemPrefix: 'BDESdeltaPOS',
  apiURLDEV: 'http://localhost:8080/v2',
  apiURLPRODVPN: 'http://172.16.1.126',
  apiURLdeltaPOS: 'https://deltapos.app',
  apiURLElCamioncito: 'http://172.16.1.12',
  apiURLpruebas: 'https://pruebas.deltapos.app/v2',
  apiURLprod: 'https://deltapos.app/v2',
  apiURL: 'https://www.deltapos.app/v2',
};

export default deltaPOS_conf
